import { render, staticRenderFns } from "./Cozinha.vue?vue&type=template&id=c4766bd8&scoped=true&"
import script from "./Cozinha.vue?vue&type=script&lang=js&"
export * from "./Cozinha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4766bd8",
  null
  
)

export default component.exports